import { RecordModel } from 'src/app/layout/record-model';
import { Component, Input, OnInit } from '@angular/core';
import * as g from 'src/app/globals';

@Component({
  selector: 'app-communication-button',
  templateUrl: './communication-button.component.html',
  styleUrls: ['./communication-button.component.less']
})
export class CommunicationButtonComponent implements OnInit {
  @Input() recordId: any;
  @Input() recordModel: RecordModel;
  @Input() moduleId: number;
  visible = false;
  area = 1;

  constructor() { }

  ngOnInit(): void {
    this.area = g.userIdentity.Area;
  }

}
